import {useFlux} from '@nlabs/arkhamjs-utils-react';
import {useEffect, useRef, useState} from 'react';

const readStatePath = <T>(state: unknown, key: string, defaultValue: T): T => {
  const value = key.split('.').reduce<unknown>((current, part) => {
    if(typeof current !== 'object' || current === null || Array.isArray(current)) return undefined;
    return (current as Record<string, unknown>)[part];
  }, state);
  return value === undefined ? defaultValue : value as T;
};

export const useStoreState = <T>(key: string, defaultValue: T): T => {
  const flux = useFlux();
  const defaultValueRef = useRef(defaultValue);
  const [value, setValue] = useState<T>(() => flux?.getState(key, defaultValueRef.current) as T);

  useEffect(() => {
    const syncValue = (state?: unknown) => setValue(
      state === undefined
        ? flux.getState(key, defaultValueRef.current) as T
        : readStatePath(state, key, defaultValueRef.current)
    );
    flux.on('arkhamjs', syncValue);
    syncValue();
    return () => { flux.off('arkhamjs', syncValue); };
  }, [flux, key]);

  return value;
};
